import {MarketStatsChartVersion, SerpMarketStatsChart} from "../../charts/SerpMarketStatsChart";
import {MarketStatsStyles} from "../../charts/MarketStatsChart";
import AdFormService from "../../../services/AdFormService";
import {Section} from "../../../services/Section";

export class MarketStats {
    private readonly element: HTMLElement | undefined;
    private readonly adFormService: AdFormService;
    constructor() {
        this.element = document.querySelector('.js-market-stats') as HTMLElement
        this.adFormService = new AdFormService();
    }

    init(marketStatsStyles: MarketStatsStyles) {
        if (this.element) {
            this.initChart(marketStatsStyles);
            this.sendSectionImpression();
        }
    }

    private initChart(marketStatsStyles: MarketStatsStyles) {
        let chartCanvas = this.element!.querySelector('.js-market-stats-chart') as HTMLElement;
        if (chartCanvas === null) {
            return;
        }
        const stats = chartCanvas.dataset.chartStats;
        if (stats === undefined) {
            return;
        }
        const config = chartCanvas.dataset.chartConfig;
        if (config === undefined) {
            return;
        }
        new SerpMarketStatsChart().init(marketStatsStyles, '.js-market-stats-chart', MarketStatsChartVersion.NO_POINTS);
    }

    private sendSectionImpression() {
        const section = this.element!.dataset.s as Section;
        if (section) {
            this.adFormService.impression(
                this.getDataAttribute(this.element!.dataset.pvi),
                section,
                [this.getDataAttribute(this.element!.dataset.li)],
                this.getDataAttribute(this.element!.dataset.ot),
            );
        }
    }

    private getDataAttribute(dataAttribute: string | undefined) {
        let pageViewId = dataAttribute;
        if (!pageViewId) pageViewId = ';'
        return pageViewId;
    }
}